module.exports = __webpack_public_path__ + "img/accelo_logo.e930151a.svg";